// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"71":"824fe465","437":"ba1962be"}[chunkId] + ".chunk.css";
};